import * as Styled from "./style";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";
import { useMatchMedia } from "~/hooks/use-match-media";
import { G_ServicePlan, type Maybe } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";

type PurchaseCardProps = {
  /** 購入作品の画質などを表示（4K・HD・SDなど） */
  title: string;
  /** レンタル期間とか視聴期間とかを格納する想定 */
  description: string;
  /** 購入ボタンのname属性に格納する文字列 */
  buttonName: string;
  /** 購入ボタンの表示名 */
  buttonMainText: string;
  /** 割引前の価格（販売価格と同等の場合は表示しない） */
  buttonStrikeMainText: string;
  /** 購入ボタンクリック時に発火するイベントハンドラ */
  onPurchasedButtonClicked: () => void;
  /** 購入済みの場合`true` */
  isPurchased?: Maybe<boolean>;
  /** プレミアム会員限定割引の有無 */
  isLimitedPremium: boolean;
};

/**
 * 購入タイプ情報を表示するコンポーネント
 * @param props {@link PurchaseCardProps}
 */
export const PurchaseCard = (props: PurchaseCardProps) => {
  const {
    title,
    description,
    buttonName,
    buttonMainText,
    buttonStrikeMainText,
    onPurchasedButtonClicked,
    isPurchased,
    isLimitedPremium,
  } = props;

  const { servicePlan } = useAuth();
  const { isSpSize } = useMatchMedia();
  const { handleClickByDevice } = useHandleClickByDevice();

  const isShowLimitedPremiumText = isLimitedPremium && servicePlan === G_ServicePlan.Premium;

  return (
    <Styled.DivRootPurchaseList>
      <Styled.SecPurchaseListItem>
        {isShowLimitedPremiumText && <Styled.ParLimitedPremiumText>DMMプレミアム特別価格</Styled.ParLimitedPremiumText>}
        <Styled.HeadingBold size="S">{title}</Styled.HeadingBold>
        {description !== "" && <Styled.SectionDescription>{description}</Styled.SectionDescription>}
      </Styled.SecPurchaseListItem>

      {isPurchased ? (
        <Styled.ParPurchasedText>購入済み</Styled.ParPurchasedText>
      ) : (
        <Styled.ButtonPurchaseOrRental
          type="button"
          iconName="basket"
          iconColor="GRAY50"
          iconSize={!isSpSize ? "XL" : "L"}
          name={buttonName}
          mainText={`${buttonMainText}円`}
          strikeMainText={buttonStrikeMainText !== "" ? `${buttonStrikeMainText}円` : undefined}
          color="GRAY50"
          bgColor="GRAY900"
          {...handleClickByDevice(onPurchasedButtonClicked)}
        />
      )}
    </Styled.DivRootPurchaseList>
  );
};
